module.exports = __webpack_public_path__ + "static/img/meeting_2.f25a792.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/parts/result/meeting_2.jpg
// module id = fQv7
// module chunks = 3